
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form",
      function () {
        return require("private-next-pages/form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form"])
      });
    }
  